import z from "zod";
import { ZodDateString } from "../zod-types/zod-date-string";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const crewDefinitionManagerSlotSchema = z
	.object({
		userId: z.string().min(1),
		startDate: ZodDateString,
		endDate: ZodStringNullable,
	})
	.superRefine((values, ctx) => {
		// The span's own order, mirrored from
		// `crew_definition_manager_slots_end_date_after_start_date_check`. Whether the slot fits
		// inside its crew's span is not checked here: the schema cannot see the crew, so the
		// handler holds that one.
		if (values.endDate && values.endDate < values.startDate) {
			ctx.addIssue({
				code: "custom",
				message: "endDate must not be before startDate",
				path: ["endDate"],
			});
		}
	});

export type CrewDefinitionManagerSlotFormSchema = z.infer<typeof crewDefinitionManagerSlotSchema>;
